import CheckCircleIcon from "@mui/icons-material/CheckCircle"
import FmdGoodIcon from "@mui/icons-material/FmdGood"
import InfoRoundedIcon from "@mui/icons-material/InfoRounded"
import LockIcon from "@mui/icons-material/Lock"
import { Box, Typography, styled } from "@mui/material"
import parse from "html-react-parser"
import { FC, useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import dialogsJson from "../../../data/dialogs.json"
import { DialogKey } from "../../dialogs/Dialogs"
import { useDialogAPI } from "../../dialogs/context/DialogProvider"
import { MapChapterPoiProps, MapPoiState } from "../Map"

export const MapChapterPoi: FC<MapChapterPoiProps> = ({
  id,
  index,
  color,
  position,
  chapters,
  progression,
}) => {
  //  CONTEXTS
  const { t } = useTranslation()
  const { startNewDialogSequence } = useDialogAPI()

  //  LOGIC
  const [state, setState] = useState<MapPoiState>()

  useEffect(() => {
    //console.info("chapters", chapters, id);

    const chapter = chapters.find((chapter) => chapter.id === id.split(".")[0])
    console.info(
      chapter,
      chapter?.poisDone.length,
      index,
      (chapter?.poisDone.length || 0) < index
    )
    const isDone = chapters.find((chapter) => chapter.poisDone.includes(id))
      ? true
      : false
    const havePopup =
      id !== ""
        ? dialogsJson[id].findIndex((dialog) => dialog.type === "popup") !== -1
        : false

    if ((chapter?.poisDone.length || 0) < index + 1) setState("locked")
    else if (isDone && havePopup) setState("havePopup")
    else if (isDone) setState("closed")
    else setState("available")
  }, [chapters, setState, id, progression])

  //  HANDLES
  const handleOnClick = (id: DialogKey) => {
    if (state === "locked") return
    startNewDialogSequence(id, chapters)
  }

  return (
    <Box
      onClick={() => handleOnClick(id)}
      sx={{
        position: "absolute",
        top: `${position.y}%`,
        left: `${position.x}%`,
        cursor: state === "locked" ? "default" : "pointer",
        width: "280px",
        textAlign: "center",
        transform: "translateY(-100%)",
        // opacity: state === "locked" ? 0.6 : 1,
      }}
    >
      <Typography
        textAlign="center"
        textTransform="uppercase"
        fontSize="0.9em"
        lineHeight="1.2"
        fontWeight="bold"
        marginBottom="0.5em"
        color={(theme) => {
          switch (state) {
            case "available":
              return `${color}.main`
            case "locked":
              return theme.palette.grey[500]
            default:
              return theme.palette.grey[600]
          }
        }}
        sx={(theme) => ({
          backgroundColor: "#fff",
          padding: "15px 0px 12px 0px",
          borderRadius: "10px",
          boxShadow: theme.shadows[2]
        })}
      >
        <Box
          component="span"
          sx={(theme) => ({
            backgroundColor: state === "locked" ? theme.palette.grey[500] : `${color}.main`,
            fontSize: "0.7em",
            color: "#fff",
            padding: "5px 8px",
            borderRadius: "999px",
            marginRight: "5px",
            lineHeight: 1,
            position: "relative",
            top: "-5px",
          })}
        >
          {index + 1}
        </Box>
        {parse(t(`ui.info.${id}`))}
      </Typography>

      <FloatingBox animated={state !== "locked" ? "true" : "false"}>
        {(state === "locked" && (
          <LockIcon sx={{ fontSize: 35, color: "grey.500" }} />
        )) ||
          (state === "available" && (
            <FmdGoodIcon sx={{ fontSize: 35 }} color={color} />
          )) ||
          (state === "havePopup" && (
            <InfoRoundedIcon sx={{ fontSize: 35 }} color={color} />
          )) ||
          (state === "closed" && (
            <CheckCircleIcon sx={{ fontSize: 35 }} color={color} />
          ))}
      </FloatingBox>
    </Box>
  )
}

const FloatingBox = styled(Box)<{ animated: string }>(({ animated }) => ({
  animation: animated === "true" ? "float 4s ease-in-out infinite" : "",
  "@keyframes float": {
    "0%, 100%": {
      transform: "translateY(0)"
    },
    "50%": {
      transform: "translateY(-7px)"
    }
  }
}))
